import React from 'react';
import { Box, Card, List, ListItemButton, Typography, Divider } from '@mui/material';
import ForumIcon from '@mui/icons-material/Forum';
import { Link, useLocation } from 'react-router-dom';

export default function ThreadListSidebar({ title = 'Threads', threads = [], currentThreadId, Icon = ForumIcon }) {
  const location = useLocation();

  if (!threads.length) return null;

  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, ml: 2 }}>
        <Icon fontSize="small" color="success" sx={{ mr: 1 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          {title}
        </Typography>
      </Box>
      <List disablePadding>
        {threads.map((thread, idx) => (
          <React.Fragment key={thread.id}>
            <ListItemButton
              component={Link}
              to={`/community/threads/${thread.id}`}
              state={{ from: location.pathname }}
              selected={currentThreadId === thread.id}
              sx={{ py: 1 }}
            >
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {thread.title}
              </Typography>
            </ListItemButton>
            {idx !== threads.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Card>
  );
}
